var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    { ref: "add-room-form" },
    [
      _c("model-field", {
        attrs: { label: "Name", type: "text", stateless: "" },
        model: {
          value: _vm.roomData.name,
          callback: function ($$v) {
            _vm.$set(_vm.roomData, "name", $$v)
          },
          expression: "roomData.name",
        },
      }),
      _vm._v(" "),
      _c("model-field", {
        attrs: { label: "Floor", type: "text", stateless: "" },
        model: {
          value: _vm.roomData.floor,
          callback: function ($$v) {
            _vm.$set(_vm.roomData, "floor", $$v)
          },
          expression: "roomData.floor",
        },
      }),
      _vm._v(" "),
      _c("model-field", {
        attrs: { label: "Purpose", type: "text", stateless: "" },
        model: {
          value: _vm.roomData.purpose,
          callback: function ($$v) {
            _vm.$set(_vm.roomData, "purpose", $$v)
          },
          expression: "roomData.purpose",
        },
      }),
      _vm._v(" "),
      _vm.showButtons
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c(
                "b-button",
                { attrs: { variant: "link" }, on: { click: _vm.clear } },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                { attrs: { variant: "primary" }, on: { click: _vm.saveRoom } },
                [_vm._v("Save")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }